import axios from "axios";
import { beforeRequestHandler, requestErrorHandler } from "./HandleGlobalInterceptors";
var getApiDomain = function () {
    var env = process.env.CURRENT_ENV;
    if (["development"].includes(env))
        return "partner-apis-dev";
    if (env && ["staging", "local"].includes(env))
        return "hub-staging";
    return "hub-production";
};
var apiDomain = getApiDomain();
var tosUrlV1 = "https://terms.".concat(apiDomain, ".360dialog.io/v1");
var instanceV1 = axios.create({ baseURL: tosUrlV1 });
var APIInstanceTos = /** @class */ (function () {
    function APIInstanceTos(instance) {
        var _this = this;
        this.registerGlobalRequestInterceptors = function () {
            _this.instance.interceptors.request.use(beforeRequestHandler, requestErrorHandler);
            _this.instance.interceptors.response.use(undefined, function (error) {
                return requestErrorHandler(error, instanceV1);
            });
        };
        this.instance = instance;
        this.registerGlobalRequestInterceptors();
    }
    Object.defineProperty(APIInstanceTos.prototype, "buffedInstances", {
        get: function () {
            return this.instance;
        },
        enumerable: false,
        configurable: true
    });
    APIInstanceTos.prototype.setAuthorizationToken = function (token) {
        try {
            this.instance.defaults.headers["Authorization"] = "Bearer ".concat(token);
        }
        catch (error) {
            console.error("Failed to set authorization token: ".concat(error));
        }
    };
    return APIInstanceTos;
}());
export var MPInstanceTos = new APIInstanceTos(instanceV1);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVxdWVzdEF4aW9zVG9TLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUmVxdWVzdEF4aW9zVG9TLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQXdCLE1BQU0sT0FBTyxDQUFDO0FBQzdDLE9BQU8sRUFDTCxvQkFBb0IsRUFDcEIsbUJBQW1CLEVBQ3BCLE1BQU0sNEJBQTRCLENBQUM7QUFFcEMsSUFBTSxZQUFZLEdBQUc7SUFDbkIsSUFBTSxHQUFHLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUM7SUFDcEMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxHQUFJLENBQUM7UUFBRSxPQUFPLGtCQUFrQixDQUFDO0lBQzlELElBQUksR0FBRyxJQUFJLENBQUMsU0FBUyxFQUFFLE9BQU8sQ0FBQyxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUM7UUFBRSxPQUFPLGFBQWEsQ0FBQztJQUNwRSxPQUFPLGdCQUFnQixDQUFDO0FBQzFCLENBQUMsQ0FBQztBQUVGLElBQU0sU0FBUyxHQUFHLFlBQVksRUFBRSxDQUFDO0FBRWpDLElBQU0sUUFBUSxHQUFHLHdCQUFpQixTQUFTLHFCQUFrQixDQUFDO0FBRTlELElBQU0sVUFBVSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsRUFBRSxPQUFPLEVBQUUsUUFBUSxFQUFFLENBQUMsQ0FBQztBQUV2RDtJQUdFLHdCQUFZLFFBQXVCO1FBQW5DLGlCQUdDO1FBY08sc0NBQWlDLEdBQUc7WUFDMUMsS0FBSSxDQUFDLFFBQVEsQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FDcEMsb0JBQW9CLEVBQ3BCLG1CQUFtQixDQUNwQixDQUFDO1lBQ0YsS0FBSSxDQUFDLFFBQVEsQ0FBQyxZQUFZLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxTQUFTLEVBQUUsVUFBQyxLQUFLO2dCQUN2RCxPQUFBLG1CQUFtQixDQUFDLEtBQUssRUFBRSxVQUFVLENBQUM7WUFBdEMsQ0FBc0MsQ0FDdkMsQ0FBQztRQUNKLENBQUMsQ0FBQztRQXhCQSxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztRQUN6QixJQUFJLENBQUMsaUNBQWlDLEVBQUUsQ0FBQztJQUMzQyxDQUFDO0lBRUQsc0JBQVcsMkNBQWU7YUFBMUI7WUFDRSxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUM7UUFDdkIsQ0FBQzs7O09BQUE7SUFFTSw4Q0FBcUIsR0FBNUIsVUFBNkIsS0FBYTtRQUN4QyxJQUFJO1lBQ0YsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLGVBQWUsQ0FBQyxHQUFHLGlCQUFVLEtBQUssQ0FBRSxDQUFDO1NBQ3JFO1FBQUMsT0FBTyxLQUFLLEVBQUU7WUFDZCxPQUFPLENBQUMsS0FBSyxDQUFDLDZDQUFzQyxLQUFLLENBQUUsQ0FBQyxDQUFDO1NBQzlEO0lBQ0gsQ0FBQztJQVdILHFCQUFDO0FBQUQsQ0FBQyxBQTdCRCxJQTZCQztBQUVELE1BQU0sQ0FBQyxJQUFNLGFBQWEsR0FBRyxJQUFJLGNBQWMsQ0FBQyxVQUFVLENBQUMsQ0FBQyJ9